/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChartDataDto } from './ChartDataDto';
import {
    ChartDataDtoFromJSON,
    ChartDataDtoFromJSONTyped,
    ChartDataDtoToJSON,
    ChartDataDtoToJSONTyped,
} from './ChartDataDto';

/**
 * 
 * @export
 * @interface OrderDashboardStatsDto
 */
export interface OrderDashboardStatsDto {
    /**
     * 
     * @type {number}
     * @memberof OrderDashboardStatsDto
     */
    totalOrderValue?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDashboardStatsDto
     */
    totalInvoicedValue?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDashboardStatsDto
     */
    remainingToBill?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDashboardStatsDto
     */
    overBilledOrdersCount?: number;
    /**
     * 
     * @type {ChartDataDto}
     * @memberof OrderDashboardStatsDto
     */
    billingStatusBreakdown: ChartDataDto;
    /**
     * 
     * @type {ChartDataDto}
     * @memberof OrderDashboardStatsDto
     */
    monthlyOrderedValue: ChartDataDto;
    /**
     * 
     * @type {ChartDataDto}
     * @memberof OrderDashboardStatsDto
     */
    monthlyInvoicedValue: ChartDataDto;
}

/**
 * Check if a given object implements the OrderDashboardStatsDto interface.
 */
export function instanceOfOrderDashboardStatsDto(value: object): value is OrderDashboardStatsDto {
    if (!('billingStatusBreakdown' in value) || value['billingStatusBreakdown'] === undefined) return false;
    if (!('monthlyOrderedValue' in value) || value['monthlyOrderedValue'] === undefined) return false;
    if (!('monthlyInvoicedValue' in value) || value['monthlyInvoicedValue'] === undefined) return false;
    return true;
}

export function OrderDashboardStatsDtoFromJSON(json: any): OrderDashboardStatsDto {
    return OrderDashboardStatsDtoFromJSONTyped(json, false);
}

export function OrderDashboardStatsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDashboardStatsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalOrderValue': json['totalOrderValue'] == null ? undefined : json['totalOrderValue'],
        'totalInvoicedValue': json['totalInvoicedValue'] == null ? undefined : json['totalInvoicedValue'],
        'remainingToBill': json['remainingToBill'] == null ? undefined : json['remainingToBill'],
        'overBilledOrdersCount': json['overBilledOrdersCount'] == null ? undefined : json['overBilledOrdersCount'],
        'billingStatusBreakdown': ChartDataDtoFromJSON(json['billingStatusBreakdown']),
        'monthlyOrderedValue': ChartDataDtoFromJSON(json['monthlyOrderedValue']),
        'monthlyInvoicedValue': ChartDataDtoFromJSON(json['monthlyInvoicedValue']),
    };
}

export function OrderDashboardStatsDtoToJSON(json: any): OrderDashboardStatsDto {
    return OrderDashboardStatsDtoToJSONTyped(json, false);
}

export function OrderDashboardStatsDtoToJSONTyped(value?: OrderDashboardStatsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalOrderValue': value['totalOrderValue'],
        'totalInvoicedValue': value['totalInvoicedValue'],
        'remainingToBill': value['remainingToBill'],
        'overBilledOrdersCount': value['overBilledOrdersCount'],
        'billingStatusBreakdown': ChartDataDtoToJSON(value['billingStatusBreakdown']),
        'monthlyOrderedValue': ChartDataDtoToJSON(value['monthlyOrderedValue']),
        'monthlyInvoicedValue': ChartDataDtoToJSON(value['monthlyInvoicedValue']),
    };
}

